/**
 * T-034 — pure prompt builder for macro (multi-step command) execution.
 *
 * Extracted so the step-chaining rule is unit-testable without network/editor:
 *  - Step 0 receives its own instruction plus the selected text/content, exactly
 *    as a single quick-command action does today ("...\n\nTexto:\n<sel>").
 *  - Step k>0 receives its own instruction plus the previous step's result
 *    ("...\n\nResultado del paso anterior:\n<respuesta k-1>").
 *
 * @param {string} stepInstruction  Instruction of the current step.
 * @param {number} index            0-based step index.
 * @param {string} selectedText     Text/content selected when the macro started.
 * @param {string} previousResult   Response from the previous step (k>0 only).
 * @returns {string} The message to POST to /ai/chat for this step.
 */
export function buildStepPrompt(stepInstruction, index, selectedText, previousResult) {
  const instr = stepInstruction || '';
  if (index === 0) {
    const text = (selectedText || '').trim();
    return text ? `${instr}\n\nTexto:\n${selectedText}` : instr;
  }
  return `${instr}\n\nResultado del paso anterior:\n${previousResult || ''}`;
}
